import { render, staticRenderFns } from "./Specialties.vue?vue&type=template&id=0e9e7494&scoped=true&"
import script from "./Specialties.vue?vue&type=script&lang=js&"
export * from "./Specialties.vue?vue&type=script&lang=js&"
import style0 from "./Specialties.vue?vue&type=style&index=0&id=0e9e7494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9e7494",
  null
  
)

export default component.exports